import { useState } from 'react';
import { Box, Button, useMediaQuery } from '@mui/material';
import useIframeListener from '../../hooks/useIFrameListener';
import { iFrameMessageTypes } from '../../types/iFrameMessageTypes';
import ReceivedMessage from './components/ReceivedMessage';

import './index.css';
import SearchBar from '../../components/searchBar';

const IFrameTesting = () => {
  const [messages, setMessages] = useState<MessageEvent[]>([]);
  const sm = useMediaQuery('(min-width: 882px)');
  const [searchValue, setSearchValue] = useState(import.meta.env.VITE_ONDEMAND_IFRAME_DEFAULT_PARAMS ?? '');
  const [iframeUrl, setIframeUrl] = useState('');
  const [iFrameKey, setIframeKey] = useState(0);

  useIframeListener(iFrameMessageTypes.StatusPage, false, (msg: MessageEvent) => {
    setMessages((prev) => [...prev, msg]);
  });

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2em',
          alignSelf: 'flex-start',
          marginBottom: '3em',
          width: '100%',
        }}>
        <SearchBar
          searchHeader="OnDemand IFrame Load"
          searchLabel="Query Params"
          searchTooltipHtml="Enter valid query parames to test the iFrame."
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          clearCards={() => {}}
          setHasTyped={() => {}}
          sm={sm}
        />
        <Button
          variant="contained"
          sx={{ height: '3em', width: '10em', marginLeft: '1em' }}
          onClick={(value) => {
            setIframeKey(iFrameKey + 1);
            setIframeUrl(`${import.meta.env.VITE_ONDEMAND_IFRAME_HOST}?${searchValue}`);
          }}>
          Load iFrame
        </Button>
      </Box>
      {iframeUrl && (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2em' }}>
          <iframe key={iFrameKey} className="iframe" src={iframeUrl} title="OnDemand iFrame Test"></iframe>

          {messages.length > 0 && (
            <Button
              variant="contained"
              sx={{ height: '3em', width: '13em', marginLeft: '1em' }}
              onClick={() => {
                setMessages([]);
              }}>
              Clear Messages
            </Button>
          )}

          {messages.map(function (data, idx) {
            return <Box key={idx}>{<ReceivedMessage message={data} delay={100 + idx * 40} />}</Box>;
          })}
        </Box>
      )}
    </>
  );
};

export default IFrameTesting;
